<template>
    <b-card title="Cargar Datos">

        <b-card-body>

        <label class="sr-only" for="cel">Colleccion</label>
      <b-input-group class="mb-2 mr-sm-2 mb-sm-0">
       <b-form-input  v-model="colleccion" id="cel" ></b-form-input>
      </b-input-group>

       <label class="sr-only" for="dire">Json</label>
      <b-input-group class="mb-2 mr-sm-2 mb-sm-0">
        <b-form-textarea v-model="datos" id="dire"   ></b-form-textarea>
      </b-input-group>
        </b-card-body>

        <template #footer>
                <b-button @click="onGuardar" variant="success">Guardar</b-button>
        </template>

    </b-card>
</template>

/* <script>
import firebase from "firebase/app";
import "firebase/firestore";

if (!firebase.apps.length)
  firebase.initializeApp({ projectId: "diazvelizexpress" });
else firebase.app();

const db = firebase.firestore();

export default {
    data(){
        return {
            datos:'',
            colleccion:''
        }
    },
    methods:{
        onGuardar(){
            
            let objeto=JSON.parse(this.datos)

            objeto.clientes.forEach(element => {
            db.collection(this.colleccion).add(element).then(()=>{
                console.log(element.Nombre);
            });    
            });
            
        }
    }
    
}
</script> */